import jsPDF from "jspdf";
import QRCode from "qrcode";

const PAGE_WIDTH_MM = 100;
const PAGE_HEIGHT_MM = 150;
const COLUMNS = 3;
const ROWS = 4;
const PER_PAGE = COLUMNS * ROWS;

const MARGIN_MM = 4;
const CELL_WIDTH_MM = (PAGE_WIDTH_MM - MARGIN_MM * 2) / COLUMNS;
const CELL_HEIGHT_MM = (PAGE_HEIGHT_MM - MARGIN_MM * 2) / ROWS;
const QR_SIZE_MM = Math.min(CELL_WIDTH_MM, CELL_HEIGHT_MM) - 8;

const buildQrCodesPdf = async (codes: string[]) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [PAGE_WIDTH_MM, PAGE_HEIGHT_MM],
  });

  for (let i = 0; i < codes.length; i++) {
    const code = codes[i];
    const positionInPage = i % PER_PAGE;

    if (i > 0 && positionInPage === 0) {
      doc.addPage([PAGE_WIDTH_MM, PAGE_HEIGHT_MM], "portrait");
    }

    const col = positionInPage % COLUMNS;
    const row = Math.floor(positionInPage / COLUMNS);

    const cellX = MARGIN_MM + col * CELL_WIDTH_MM;
    const cellY = MARGIN_MM + row * CELL_HEIGHT_MM;

    const dataUrl = await QRCode.toDataURL(code, { margin: 0, width: 300 });

    const qrX = cellX + (CELL_WIDTH_MM - QR_SIZE_MM) / 2;
    const qrY = cellY + 1;

    doc.addImage(dataUrl, "PNG", qrX, qrY, QR_SIZE_MM, QR_SIZE_MM);

    doc.setFontSize(6);
    doc.text(code, cellX + CELL_WIDTH_MM / 2, qrY + QR_SIZE_MM + 3, {
      align: "center",
      maxWidth: CELL_WIDTH_MM,
    });
  }

  return doc;
};

export const downloadQrCodesPdf = async (codes: string[]) => {
  const doc = await buildQrCodesPdf(codes);
  doc.save(`qr-codes-${Date.now()}.pdf`);
};

export const openQrCodesPdf = async (codes: string[]) => {
  const doc = await buildQrCodesPdf(codes);
  const blobUrl = doc.output("bloburl");
  window.open(blobUrl as unknown as string, "_blank");
};
